// extracted by mini-css-extract-plugin
export var bgOverlay = "PageHeader-module__bgOverlay___gcFOT";
export var header = "PageHeader-module__header___a2AM-";
export var headerContent = "PageHeader-module__headerContent___r5nkJ";
export var heading = "PageHeader-module__heading___SQn56";